module.exports = __webpack_public_path__ + "static/media/BLS.3023d372.png";